<template>
    <div>
        <div class="full split-bottom">
            <div class="full">
                <div class="mainheader">
                    <div>
                        {{ $t('pages.employeeDocuments.documentsAndRecords') }}
                    </div>
                </div>
            </div>
            <div v-if="files !== undefined && files.length > 0 && !documentListView" class="full">
                <div v-bind:key="document.documentType" v-for="document in  documentTypes"
                     class="full" style="border-bottom: 1px solid var(--md)">
                    <labelc type="header" class="w600"
                            :text="documentTypeFormat(document.documentType)"
                            :styleText="{marginLeft: '0', fontSize: '22px'}"
                            @click="toggleSimpleEntries(document.documentType)" />
                    <labelc type="header" :text="collapsedState[document.documentType] ? '⏶' : '⏷'" style="width: auto"
                            :styleText="{marginLeft: '0', fontSize: '22px'}"
                            @click="toggleSimpleEntries(document.documentType)" />
                    <div v-if="collapsedState[document.documentType]" class="doc-table">
                        <datatablesimple :state="getStateForFiles(filesFiltered(document.documentType))" />
                    </div>
                </div>
            </div>
            <div v-if="files !== undefined && files.length > 0 && documentListView" class="full">
                <datatablesimple :state="getStateForFiles(formattedFiles, true)" />
            </div>
            <div class="full" v-if="(files === undefined || files.length === 0) && sharepointFiles.length === 0">
                <div class="full">
                    <div class="label">{{ $t('pages.employeeDocuments.noDocumentsUploaded') }}</div>
                </div>
            </div>
        </div>
        <br/>
        <div v-if="mlEmployeeFiles.length > 0" class="full split-bottom">
            <div class="full">
                <div class="mainheader">
                    <div>
                        {{ $t('pages.employeeDocuments.documentsFromMl') }}
                    </div>
                </div>
            </div>
            <div v-if="mlEmployeeFiles.length > 0" class="full doc-table">
                <datatablesimple :state="mlEmployeeState"/>
            </div>
        </div>
        <br/>
        <div v-if="socialInsuranceRegistrations.length > 0" class="full split-bottom">
            <div class="full">
                <div class="mainheader">
                    <div>
                        {{ $t('pages.employeeDocuments.socialSecurityRegistrations') }}
                    </div>
                </div>
            </div>
            <div v-if="socialInsuranceRegistrations.length > 0" class="full doc-table">
                <datatablesimple :state="socialInsuranceState"/>
            </div>
        </div>
        <br/>
        <div v-if="hasSharepoint && hasSharepointConfig" class="full split-bottom">
            <div class="full">
                <div class="mainheader">
                    <div class="half">
                        {{ $t('pages.employeeDocuments.sharepointDocuments') }}
                    </div>
                    <div class="half right">
                        <buttonc type="rectangle green" :styleIcon="{'font-size': '13px'}" icon="fas fa-upload"
                                 style="width: 100px"
                                 :label="$t('pages.employeeDocuments.upload')" @click="modalCreatefile = true"/>
                    </div>
                </div>
            </div>
            <div v-if="sharepointLoading">
                <i class="fas fa-spinner"></i>
            </div>
            <div v-else class="full">
                <div class="full" v-if="sharepointState.canGoUp">
                    <div class="full">
                        <buttonc type="rectangle green" :styleIcon="{'font-size': '13px'}" icon="fas fa-chevron-left"
                                 style="width: 100px; float: left"
                                 :label="$t('global.ui.back')" @click="listParent()"/>
                    </div>
                    <div class="full">
                        <div class="header">
                            <div class="label">
                                {{
                                    sharepointState.canGoUp ? sharepointState.currentFolder.name : $t('store.roles.employeeDocuments')
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="sharepointEntries.length > 0">
                    <div class="full">
                        <div class="header">
                            <div class="label">{{ $t('pages.employeeDocuments.mainDirectory') + ': ' + employee.personnelId }}</div>
                        </div>
                    </div>
                </div>
                <datatablesimple :state="sharepointEntriesState"/>
            </div>
        </div>

        <div class="discarder" v-if="modalCreatefile || modalFilldocuments || modalEditfile || modalDeletefile ||
                modalDeletecontractfile || modalUploadError"
             @click="modalCreatefile = false; modalFilldocuments = false; modalEditfile = false; modalDeletefile = false;
                modalDeletecontractfile = false; modalUploadError = false;">
        </div>
        <div class="md-card" v-if="modalCreatefile || modalEditfile">
            <h6 class="md-card-header" style="text-align: left">
                {{ modalEditfile ? $t('global.ui.editX', [$t('global.ui.file')]) : $t('pages.employeeDocuments.uploadFile') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalCreatefile = false; modalEditfile = false; resetFile()"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select" style="display: flex; justify-content: center; overflow-y: auto; height: calc(98vh - 360px)">
                    <div v-if="previewPdf && pageCount > 1 && page > 1" @click="prevPage"
                         class="previous fas fa-chevron-left"></div>
                    <div class="preview-box" v-bind:style="{'margin-left': previewPdf && pageCount > 1 && page == 1? '37px' : '5px', 'margin-right': previewPdf && pageCount > 1 && page == pageCount? '37px' : '5px', background: !preview ?'var(--contrast-0)' : '', border: !preview ? 'dashed 1px var(--contrast-3)' : 'none' }">
                        <input v-if="!preview && !previewPdf" class="inputFile" type="file" id="fileUploader" @change="fileSelected"
                               accept="image/jpeg, image/png, application/pdf"/>
                        <label v-if="!preview && !previewPdf" for="fileUploader" id="fileUploaderLabel">
                            <i class="fas fa-upload"></i>
                            Datei auswählen...
                        </label>
                        <div v-if="uploading" class="loading">
                            <i class="fas fa-spinner"></i>
                        </div>
                            <div>
                                <buttonc v-if="modalCreatefile && (preview || previewPdf)" type="rectangle red" class="remove-picture"
                                         :label="preview ? $t('global.ui.deleteX', [$t('global.ui.photo')]) : $t('global.ui.deleteX', ['PDF'])"
                                         :icon="'fas fa-trash'" :styleIcon="{ color: 'white' }" style="width: 120px; z-index: 100"
                                         @click="resetFile"/>
                                <img id="imgPreview" class="img-preview" :src="modalEditfile ? employeeFile.url : previewSrc" alt=""/>
                            </div>
                        <div v-if="previewPdf" style="width: 100%; height: 100%; overflow-y: hidden;">
                            <pdf
                                style="width: calc(100% - 16px); margin: 8px; height: 85%; overflow-y: hidden;"
                                :src="modalEditfile ? employeeFile.url : previewPdfSrc"
                                @numPages="pageCountLoaded"
                                @num-pages="pageCountLoaded"
                                :page="page"
                            ></pdf>
                        </div>
                    </div>
                    <div v-if="previewPdf && pageCount > 1 && page < pageCount" @click="nextPage"
                         class="next fas fa-chevron-right" style="text-align: right"></div>
                </div>
                <div class="md-card-select settings">
                    <labelc type="header" class="md-label" :text="$t('pages.employeeData.name') + ':'"/>
                    <div class="cd-input"><input v-model="employeeFile.name" id="filename"
                           v-bind:class="{bottomline: employeeFile.name === undefined || employeeFile.name === ''}"/></div>
                </div>
                <div class="md-card-select settings">
                    <labelc type="header" class="md-label" :text="$tc('global.general.type') + ':'"/>
                    <div class="select-style" style="margin-right:35px;">
                        <select id="documenttype" v-model="employeeFile.documentType">
                            <option v-for="type in $helpers.documentTypes(true)" v-bind:key="type.key"
                                    :value="type.value">
                                {{ type.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="md-card-select settings">
                    <labelc type="header" class="md-label" :text="$t('pages.employeeDocuments.hasExpirationDate') + ':'"/>
                    <div class="cb-group" style="margin-right: 32px;">
                        <checkbox id="hasValidUntil" :value="employeeFile.hasValidUntil"
                                  @Update="employeeFile.hasValidUntil = !employeeFile.hasValidUntil"/>
                    </div>
                    <labelc v-if="modalCreatefile" type="header" class="md-label" :text="$t('pages.employeeDocuments.sensitiveDocument') + ':'"/>
                    <div v-if="modalCreatefile" class="cb-group">
                        <checkbox id="sensitive" :value="employeeFile.sensitive"
                                  @Update="employeeFile.sensitive = !employeeFile.sensitive;"/>
                    </div>
                    <labelc v-if="modalCreatefile" type="header" class="md-label" :text="$t('pages.employeeDocuments.visibleForEmployee') + ':'"/>
                    <div v-if="modalCreatefile" class="cb-group">
                        <checkbox id="visibleForEmployee" :value="employeeFile.visibleForEmployee"
                                  @Update="employeeFile.visibleForEmployee = !employeeFile.visibleForEmployee;"/>
                    </div>
                </div>
                <div v-if="employeeFile.hasValidUntil" class="md-card-select settings">
                    <labelc type="header" class="md-label" style="margin-bottom: 4px;" :text="$t('global.general.expiringDate') + ':'"/>
                    <input v-model="employeeFile.validUntil" type="date" id="validUntil" class="input"/>
                </div>
            </div>
            <div class="md-card-actions">
                <div class="mright35" style="margin-top:12px">
                    <buttonc type="rectangle green right" :styleIcon="{'font-size': '13px'}"
                             style="width: 100px" :label="$t('global.ui.save')" @click="upsertFile"/>
                </div>
            </div>
        </div>
        <div class="md-card" v-if="modalFilldocuments">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('pages.employeeDocuments.fillDocuments') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalFilldocuments = false; resetFile()"></i>
            </h6>
            <div class="md-card-body">
                <div v-if="loading" class="md-card-select noborder">
                    <div style=" margin: 48px 0; width: 100%; text-align: center; font-family: DistrictProThin,serif;">
                        <div style="margin-bottom: 16px;"><i class="fas fa-rocket fa-7x" style="color: var(--md);"></i>
                        </div>
                        <div style="font-family: DistrictProThin,serif; color: var(--contrast-4);">&nbsp;{{
                                loadingText
                            }}
                        </div>
                    </div>
                </div>
                <div v-if="!loading && docfillpage === 1">
                    <div v-for="type in templateTypes" v-bind:key="type.id">
                        <labelc type="header" class="md-label" :text="type.label_de"
                        :styleText="titleStyle" :style="headerLabelStyle"/>
                        <div v-for="t in templatesWithType(type)" v-bind:key="t.id" class="md-card-select template-line">
                            <labelc type="label" class="md-label" :text="t.name" style="width: 75%;"/>
                            <div class="cb-group-template">
                                <checkbox :value="t.checked" @Update="t.checked = !t.checked"/>
                            </div>
                        </div>
                    </div>
                    <labelc type="header" class="md-label" text="Optionen"
                        :styleText="titleStyle" :style="headerLabelStyle"/>
                    <div class="md-card-select template-line">
                        <labelc type="label" class="md-label" :text="$t('pages.employeeDocuments.futureContract')" style="width: 75%"/>
                        <div class="cb-group-template">
                            <checkbox :value="fillFutureContract" @Update="toggleFillFutureContract()"/>
                        </div>
                    </div>
                    <div class="md-card-select template-line">
                        <labelc type="label" class="md-label" :text="$t('pages.employeeDocuments.pastContract')" style="width: 75%"/>
                        <div class="cb-group-template">
                            <checkbox :value="fillPastContract" @Update="toggleFillPastContract()"/>
                        </div>
                    </div>
                </div>
                <div v-if="!loading && docfillpage === 2">
                    <labelc type="header" class="md-label" :text="$tc('pages.employeeDocuments.filledDocument', filledDocuments.length)"
                    :styleText="titleStyle" :style="headerLabelStyle"/>
                    <div v-for="doc in filledDocuments" v-bind:key="doc.fileName" class="md-card-select file-line">
                        <labelc type="label" class="md-label" :text="docFilename(doc)" style="width: 75%;"/>
                        <div v-if="!docxDocuments" class="button small" @click="openFilledDocumentB64(doc)">
                            <div class="label">
                                {{ $t('global.ui.open') }}
                            </div>
                        </div>
                        <div class="button small" @click="saveFilledDocumentB64(doc)" style="margin-left: 12px;">
                            <div class="label">
                                {{ $t('global.general.download') }}
                            </div>
                        </div>
                    </div>
                    <div v-if="filledDocuments.length > 1" class="full">
                        <div class="right" style="margin: 16px 32px 0 0;">
                            <div class="button small" @click="saveAllDocsB64()">
                                <div class="label">
                                    {{ $t('pages.employeeDocuments.downloadAll') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!loading && docfillpage === -1" class="md-card-select">
                    <labelc type="header" :text="'Vorgang fehlgeschlagen'" style-label="width: 100%" />
                    <div class="data full">{{ $t('pages.employeeDocuments.fillTemplateError') }}</div>
                    <div class="data full">{{ $t('pages.employeeDocuments.pleaseCheckAndReport') }}</div>
                </div>
            </div>
            <div class="md-card-actions">
                <div class="mright35 right" style="margin-top:12px">
                    <buttonc v-if="!loading && docfillpage === 1" type="no-border" :label="$t('global.ui.cancel')"
                                 @click="modalFilldocuments = false; resetFile()"/>
                        <buttonc v-if="!loading && docfillpage === 1" type="no-border cyan"
                                 :label="$t('pages.employeeDocuments.uploadOwnTemplate')" style="width: 200px"
                                 @click="modalFilldocuments = false; startFillDocuments(true);"/>
                        <buttonc v-if="!loading" type="no-border green"
                                 :label="docfillpage === 1? $t('pages.employeeDocuments.fillDocuments') : $t('roster.main.finished')"
                                 @click="docfillpage === 1? fillSelecetedDocuments() : endFillDocuments()"/>
                </div>
            </div>
        </div>
        <div class="md-card" v-if="modalDeletefile">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.ui.deleteX', [$t('global.ui.file')]) }}
                <i class="fas fa-times" style="float: right"
                   @click="modalDeletefile = false; resetFile()"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    {{ $t('pages.employeeDocuments.deleteFileQuery') }}
                </div>
                <div v-if="fileerror" class="md-card-select my-1">
                    {{ $t('global.ui.deletedErrorX', [$t('global.ui.file')]) }}
                </div>
                <div class="mright35" style="margin-top:12px">
                    <buttonc type="rectangle red right" :styleIcon="{'font-size': '13px'}"
                             style="width: 100px" :label="$t('global.ui.delete')" @click="deleteFile"/>
                </div>
                <div class="mright35" style="margin-top:12px">
                    <buttonc type="rectangle right" :styleIcon="{'font-size': '13px'}"
                             style="width: 100px" :label="$t('global.ui.cancel')" @click="modalDeletefile = false; resetFile()"/>
                </div>
            </div>
        </div>
        <div class="md-card" v-if="modalDeletecontractfile">
            <h6 class="md-card-header" style="text-align: left">
                Vertragsdokument löschen
                <i class="fas fa-times" style="float: right"
                   @click="modalDeletefile = false; resetFile()"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    {{ $t('pages.employeeDocuments.deleteFileHelp') }}
                    {{ $t('pages.employeeDocuments.deleteFileQuery') }}
                </div>
                <div v-if="fileerror" class="md-card-select my-1">
                    {{ $t('global.ui.deletedErrorX', [$t('global.ui.file')]) }}
                </div>
                <div class="mright35" style="margin-top:12px">
                    <buttonc type="rectangle red right" :styleIcon="{'font-size': '13px'}"
                             style="width: 100px" :label="$t('global.ui.delete')" @click="deleteFile"/>
                </div>
                <div class="mright35" style="margin-top:12px">
                    <buttonc type="rectangle right" :styleIcon="{'font-size': '13px'}"
                             style="width: 100px" :label="$t('global.ui.cancel')"
                             @click="modalDeletecontractfile = false; resetFile()"/>
                </div>
            </div>
        </div>
        <div class="md-card" v-if="modalUploadError">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.notifications.error') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalUploadError = false; resetFile()"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select my-1">
                    {{ $t('pages.employeeDocuments.fileUploadAdvice', [uploadErrorMessage]) }}
                </div>
                <div class="mright35" style="margin-top:12px">
                    <buttonc type="rectangle right green" :styleIcon="{'font-size': '13px'}"
                             style="width: 100px" :label="$t('global.ui.ok')" @click="closeErrorModal"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import pdf from 'vue-pdf'
import {mapGetters} from 'vuex';
import {saveAs} from 'file-saver';

export default {
    name: 'employeedocuments',
    props: ["employeeId", "employee", "contract", "displayedDocumentTypes", "documentListView"],
    components: {
        pdf
    },
    computed: {
        ...mapGetters(['storeId', 'isSuperUser', 'anonMode', 'externalServicesMap', 'employeeFilesMap', 'employeeContractArray', 'storeSettings', 'userInfo', 'permissions']),
        employeeFilenameAppendix(){
            let appendix = '';
            if(this.employee){
                appendix += '_' + this.employee.lastName + '_' + this.employee.firstName;
                let pId = this.employee.personnelId;
                if(pId != null && pId != undefined && pId != ""){
                    appendix += '_' + pId;
                }
            }
            return appendix;
        },
        canEditFiles() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 83);
                if (perm && perm.level > 2) {
                    val = true;
                }
            });

            return val;
        },
        canViewFiles() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 81);
                if (perm && perm.level > 1) {
                    val = true;
                }
            });

            return val;
        },
        canViewSensitiveFiles() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 81);
                if (perm && perm.level > 2) {
                    val = true;
                }
            });

            return val;
        },
        socialInsuranceState() {
            let view = this;

            if (view.socialInsuranceRegistrations === undefined || view.socialInsuranceRegistrations.length < 1) {
                return null;
            }

            let data = Object.values(view.socialInsuranceRegistrations);

            let columns = {
                registrationDate: this.$t('pages.employeeDocuments.registration'),
                deregistrationDate: this.$t('pages.employeeDocuments.deRegistration'),
                registeredBy: this.$t('pages.employeeDocuments.registeredBy'),
            };
            let nameColumns = ['registrationDate',
                'deregistrationDate',
                'registeredBy',
                'actions',];
            let nameColumnWidth = 20;
            if (view.storeSettings.country === 1) {
                columns.elda = "ELDA";
                nameColumns.push('elda');
            }
            columns.actions = " ";
            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'registrationDate');
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'deregistrationDate');
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'registeredBy');
            if (view.storeSettings.country === 1) {
                view.$helpers.buildHeaderMapLabel(state.headerMap, 'elda');
                state.headerMap['elda'].componentStateBuilders = [(data) => {
                    return this.displayBooleanState(data.elda);
                }];
            }
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
            state.headerMap.actions.componentStateBuilders = [];
            state.headerMap.actions.componentStateBuilders.push(
                (data) => {
                    if (data.registrationDocument) {
                        return {
                            componentType: 'buttonc',
                            tooltip: () => {
                                return this.$t('global.ui.open');
                            },
                            type: 'button icon-overlay square',
                            icon: 'fas fa-envelope-open',
                            customEvents: {
                                click: () => {
                                    view.openFile(data.registrationDocument);
                                }
                            }
                        }
                    }
                    else if (data.eldaRequestId) {
                        return {
                            componentType: 'buttonc',
                            tooltip: () => {
                                return this.$t('global.ui.open');
                            },
                            type: 'button icon-overlay square',
                            icon: 'fas fa-envelope-open',
                            customEvents: {
                                click: () => {
                                    view.openEldaFile(data.eldaRequestId);
                                }
                            }
                        }
                    }

                },


            );


            let entries = Object.entries(state.headerMap);
            for (let x in entries) {
                if (nameColumns.includes(entries[x][0])) {
                    entries[x][1].width = nameColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '12px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.alwaysUnfold = false;

            return state;
        },
        sharepointEntriesState() {
            let view = this;

            if (view.sharepointEntries === undefined || view.sharepointEntries.length < 1) {
                return null;
            }

            let data = Object.values(view.sharepointEntries);

            let columns = {
                symbol: " ",
                name: this.$t('pages.employeeData.name'),
                createdDateTime: this.$t('global.general.created'),
                expiry: this.$t('global.general.expiringDate'),
                actions: " ",
            };

            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'symbol');
            state.headerMap.symbol.componentStateBuilders = [() => {
                return {
                    componentType: 'buttonc',
                    type: 'button icon-overlay square',
                    icon: 'fas fa-file',
                    styleButton: {marginLeft: 'calc(50%-13px)'},
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
            state.headerMap['name'].componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: data.name,
                    },
                    styleLabel: {
                        textAlign: 'left',
                        background: '',
                        height: '100%',
                    }
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'createdDateTime');
            state.headerMap.createdDateTime.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: view.creationDateFormat(data.createdDateTime),
                    },
                    styleLabel: view.$helpers.styleLabel,
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'expiry');
            state.headerMap.expiry.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: data.expiry,
                    },
                    styleLabel: view.$helpers.styleLabel,
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
            state.headerMap.actions.componentStateBuilders = [];
            state.headerMap.actions.componentStateBuilders.push((data) => {
                if (data.isFolder) {
                    return {
                        componentType: 'buttonc',
                        type: 'button icon-overlay square',
                        tooltip: () => {
                            return this.$t('pages.employeeDocuments.openFolder');
                        },
                        icon: 'fas fa-folder',
                        customEvents: {
                            click: () => {
                                view.getSharepointFiles(data);
                            }
                        }
                    }
                } else {
                    return {
                        componentType: 'buttonc',
                        type: 'button icon-overlay square',
                        tooltip: () => {
                            return this.$t('pages.employeeDocuments.openInSharepoint');
                        },
                        icon: 'fas fa-envelope-open',
                        customEvents: {
                            click: () => {
                                view.openSharepointFile(data);
                            }
                        }
                    }
                }
            });
            state.headerMap.actions.componentStateBuilders.push((data) => {
                if (data.isFolder) {
                    return {}
                } else {
                    return {
                        componentType: 'buttonc',
                        type: 'button icon-overlay square',
                        tooltip: () => {
                            return this.$t('global.general.openDocument');
                        },
                        icon: 'fas fa-download',
                        customEvents: {
                        click: () => {
                            view.downloadSharepointFile(data);
                        }
                    }
                    }
                }
            });

            let entries = Object.entries(state.headerMap);
            entries[0][1].key = 'symbol';
            entries[0][1].width = '5%';
            entries[1][1].key = 'name';
            entries[1][1].width = '50%';
            entries[2][1].key = 'createdDateTime';
            entries[2][1].width = '15%';
            entries[3][1].key = 'expiry';
            entries[3][1].width = '15%';
            entries[4][1].key = 'actions';
            entries[4][1].width = '15%';

            state.headerStyles = {fontSize: '10px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.alwaysUnfold = false;

            return state;
        },
        mlEmployeeState() {
            let view = this;

            if (view.mlEmployeeFiles === undefined || view.mlEmployeeFiles.length < 1) {
                return null;
            }

            let data = Object.values(view.mlEmployeeFiles);

            let columns = {
                symbol: " ",
                name: this.$t('pages.employeeData.name'),
                documentType: this.$tc('global.general.type'),
                uploadedByEmployee: this.$t('pages.employeeDocuments.employeeUpload'),
                confirmed: this.$t('global.ui.approved'),
                sensitive: this.$t('pages.employeeDocuments.sensitive'),
                creationDateFormatted: this.$t('store.settings.date'),
                validUntil: this.$t('global.general.expiringDate'),
                actions: " ",
            };

            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'symbol');
            state.headerMap.symbol.componentStateBuilders = [() => {
                return {
                    componentType: 'buttonc',
                    type: 'button icon-overlay square',
                    icon: 'fas fa-file',
                    styleButton: {marginLeft: 'calc(50%-13px)'},
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
            state.headerMap['name'].componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.documentNameTruncatedFormat(data.name),
                    },
                    styleLabel: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '',
                        height: 'calc(100% - 10px)',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'documentType');
            state.headerMap['documentType'].componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.documentTypeTruncatedFormat(data.documentType),
                    },
                    styleLabel: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'left',
                        justifyContent: 'left',
                        background: '',
                        height: 'calc(100% - 10px)',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'uploadedByEmployee');
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'confirmed');
            state.headerMap['confirmed'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.confirmed);
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'sensitive');
            state.headerMap['sensitive'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.sensitive);
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDateFormatted');
            state.headerMap.creationDateFormatted.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: view.creationDateFormat(data.created_at),
                    },
                    styleLabel: view.$helpers.styleLabel,
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'validUntil');
            state.headerMap.validUntil.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: view.validUntilFormat(data.validUntil),
                    },
                    styleLabel: view.$helpers.styleLabel,
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
            state.headerMap.actions.componentStateBuilders = [
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.download')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-download',
                        customEvents: {
                            click: () => {
                                view.downloadFile(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.open')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-envelope-open',
                        customEvents: {
                            click: () => {
                                view.openFile(data);
                            }
                        }
                    }
                },
            ];

            let entries = Object.entries(state.headerMap);
            entries[0][1].key = 'icon';
            entries[0][1].width = '3%';
            entries[1][1].key = 'name';
            entries[1][1].width = '15%';
            entries[2][1].key = 'documentType';
            entries[2][1].width = '10%';
            entries[3][1].key = 'uploadedByEmployee';
            entries[3][1].width = '7%';
            entries[4][1].key = 'confirmed';
            entries[4][1].width = '5%';
            entries[5][1].key = 'sensitive';
            entries[5][1].width = '5%';
            entries[6][1].key = 'creationDateFormatted';
            entries[6][1].width = '15%';
            entries[7][1].key = 'validUntil';
            entries[7][1].width = '15%';
            entries[8][1].key = 'actions';
            entries[8][1].width = '15%';

            state.headerStyles = {fontSize: '10px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.alwaysUnfold = false;

            return state;
        },
        hasSharepoint(){
            // TODO: has to be defined somewhere, e.g. sharepoint license in settings, free of charge for FN Köck
            return this.$store.state.storeId == 74 || this.$store.state.storeId == 76;
        },
        hasSharepointConfig(){
          var sid = null;
          var hasConfig = false;
          Object.values(this.externalServicesMap).forEach((s) => {
              if(s.name == "Microsoft Sharepoint") sid = s.id;
          });
          console.log(this.externalDataMap);
          if(sid != null){
              Object.values(this.externalDataMap).forEach((ed) => {
                  if(ed.externalServiceId == sid) hasConfig = true;
              });
          }
          return hasConfig;
        },
        sharepointRootID(){
            if(this.hasSharepoint && this.hasSharepointConfig){
                return this.sharepointConfig.data.map.rootFolderId;
            }
            return null;
        },
        sharepointConfig(){
            var sid = this.sharepointServiceId;
            var config = {
                    'username': '',
                    'password': '',
                    'data': {
                        'map': {
                            "tenant_id": '',
                            "client_id": '',
                            "client_secret": '',
                            "driveId": '',
                            "rootFolderId": ''
                        }
                    }
            };
            if(sid != null){
                Object.values(this.externalDataMap).forEach((ed) => {
                    if(ed.externalServiceId == sid) config = ed;
                });
            }
            return config;
        },
        sharepointServiceId(){
            var sid = null;
            Object.values(this.externalServicesMap).forEach((s) => {
                console.log(s);
                if(s.name == "Microsoft Sharepoint") sid = s.id;
            });
            return sid;
        },
        sharepointEntries(){
            var entries = [];
            /* if(this.sharepointState.canGoUp){
                entries.push({
                    name: this.sharepointState.currentFolder.name,
                    navigateUp: true,
                    folder: this.sharepointState.currentFolder
                });
            } */
            if(this.sharepointFolders != undefined){
                this.sharepointFolders.forEach((f) => {
                    f.isFolder = true;
                });
                entries = entries.concat(this.sharepointFolders);
            }
            if(this.sharepointFiles != undefined){
                this.sharepointFiles.forEach((f) => {
                    let expiry = "";
                    if(f.listItem.fields){
                        expiry = f.listItem.fields['ABLAUFDATUM'];
                        if(expiry && expiry != "") expiry = this.$helpers.extractDateStringTZ(expiry, "DD.MM.YYYY");
                    }
                    f.expiry = expiry;
                    f.isFolder = false;
                });
                entries = entries.concat(this.sharepointFiles);
            }
            return entries;
        },
        files() {
            let overviewA = [];
            Object.values(this.employeeFilesMap).filter(f => f.employeeId == this.$props.employeeId).forEach(f => {

                overviewA.push(f);
            })
            overviewA.sort((a,b) => {
                return (this.documentTypeFormat(a.documentType) > this.documentTypeFormat(b.documentType))? 1 : -1;
            });
            return overviewA;
        },
        documentTypes(){
            let filtered = [];
            if(this.files != null){
                this.files.forEach((f) => {
                    if(this.displayedDocumentTypes.includes(f.documentType)) {
                        let item = {};
                        item.documentType = f.documentType;
                        item.showDetails = true;
                        if(filtered.filter(i => i.documentType === item.documentType).length === 0) {
                            filtered.push(item);
                        }
                    }
                });
            }

            return filtered;
        },
        formattedFiles() {
            let filtered = [];
            if(this.files != null){
                this.files.forEach((f) => {
                    if(this.displayedDocumentTypes.includes(f.documentType)) {
                        let formattedFile = Object.assign({}, f);
                        formattedFile.creationDateFormatted = this.creationDateFormat(formattedFile.creationDate)
                        formattedFile.validUntilFormatted = this.validUntilFormat(formattedFile.validUntil)
                        filtered.push(formattedFile);
                    }

                });
            }

            return filtered;
        },
        formattedMLFiles() {
            let filtered = [];
            if(this.mlEmployeeFiles != null){
                this.mlEmployeeFiles.forEach((f) => {
                    if(this.displayedDocumentTypes.includes(f.documentType)) {
                        let formattedFile = Object.assign({}, f);
                        formattedFile.creationDateFormatted = this.creationDateFormat(formattedFile.created_at)
                        formattedFile.validUntilFormatted = this.validUntilFormat(formattedFile.validUntil)
                        filtered.push(formattedFile);
                    }

                });
            }

            return filtered;
        },
    },
    watch: {
        employeeId: function(val, oldVal){
            this.resetFile();
            this.sharepointFolders = [];
            this.sharepointFiles = [];
            this.refresh();
        },
        displayedDocumentTypes: function(val, oldVal){
            //this.filterFiles();
        }
    },
    data() {
        return {
            modalFilldocuments: false,
            modalCreatefile: false,
            modalEditfile: false,
            modalDeletefile: false,
            modalDeletecontractfile: false,
            modalUploadError: false,
            collapsedState: {},
            fileTypeMapping: {
                "image/png" : "png",
                "image/jpeg": "jpg",
                "application/pdf" : "pdf",
                "text/plain": "txt"
            },
            sharepointFields: [{
                key: "icon",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd fileIcon'
            },{
                key: "name",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            },{
                key: "createdDateTime",
                label: this.$t('global.general.created'),
                formatter: "creationDate",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            },{
                key: "expiry",
                label: this.$t('global.general.expiringDate'),
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            },
            {
                key: "actions",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }
            ],

            fields: [{
                key: "icon",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd fileIcon',
                thStyle: {
                    width: '40px !important'
                }

            },{
                key: "name",
                label: this.$t('pages.employeeData.name'),
                sortable: false,

                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                formatter: "documentNameTruncatedFormat",
                thStyle: {
                    width: '150px !important'
                }
            },{
                key: "uploadedByEmployee",
                label: this.$t('pages.employeeDocuments.employeeUpload'),
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '50px !important'
                }

            },{
                key: "confirmed",
                label: this.$t('global.ui.approved'),
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '50px !important'
                }

            }, {
                key: "sensitive",
                label: this.$t('pages.employeeDocuments.sensitive'),
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '50px !important'
                }

            },
            {
                key: "visibleForEmployee",
                label: this.$t('pages.employeeDocuments.visible'),
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '50px !important'
                }

            },
            {
                key: "creationDateFormatted",
                label: this.$t('store.settings.date'),
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '130px !important'
                }
            }, {
                key: "validUntilFormatted",
                label: this.$t('global.general.expiringDate'),
                formatter: "validUntil",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '80px !important'
                }
            }, {
                key: "actions",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                thStyle: {
                    width: '200px !important'
                }
            }],
            employeeFile: {
                name: "",
                documentType: "UNDEFINED",
                hasValidUntil: false,
                sensitive: false,
                visibleForEmployee: true,
                validUntil: this.$helpers.getMomentTZ().add(7,'days').format("YYYY-MM-DD"),
                upload: null,
            },
            backupFile: {
                name: "",
                documentType: "UNDEFINED",
                hasValidUntil: false,
                validUntil: this.$helpers.getMomentTZ().add(7,'days').format("YYYY-MM-DD"),
                upload: null,
            },
            sharepointLoading: false,
            sharepointState: {
                canGoUp: false,
                currentFolder: null,
                currentId: null,
                parentFolder: null,
                parentId: null
            },
            sharepointFiles: [],
            sharepointFolders: [],
            sharepointToken: null,
            externalDataMap: {},
            fileId: "",
            docType: "",
            currentrow: {},
            uploading: false,
            uploadErrorMessage: '',
            preview: false,
            previewSrc: "",
            previewPdf: false,
            previewPdfSrc: "",
            pageCount: 0,
            page: 1,
            fileerror: false,
            loading: false,
            loadingText: this.$t('workBalance.averages.loading'),
            templateTypes: [],
            documentTemplates: [],
            docfillpage: 1,
            filledDocuments: [],
            docxDocuments: false,
            fillFutureContract: false,
            fillPastContract: false,
            filledDocumentsType: '',
            socialInsuranceRegistrations: [],
            mlEmployeeFiles: [],
            fillMlTemplates: false,
            titleStyle: {margin: '0', padding: '6px', fontSize: '16px'},
            headerLabelStyle: "background: var(--md); color: white; width: 100%; border-bottom: 1px solid var(--md); margin: 8px 8px 0px 0;"

        }
    },
    created: function () {
        this.refresh();
    },
    // methods that implement data logic.
    methods: {

        filesFiltered(docType){
          let filtered = [];
          if(this.files != null){
                this.files.forEach((f) => {
                    if(docType == null || docType === f.documentType){
                        let formattedFile = Object.assign({}, f);
                        formattedFile.creationDateFormatted = this.creationDateFormat(formattedFile.creationDate)
                        formattedFile.validUntilFormatted = this.validUntilFormat(formattedFile.validUntil)
                        filtered.push(formattedFile);
                    }
                });
          }

          return filtered;
        },
        getStateForFiles(data, includeDocumentType = false) {
            let view = this;


            let stateDef = {};
            if(includeDocumentType){
                stateDef = {
                    symbol: " ",
                    name: this.$t('pages.employeeData.name'),
                    documentType: this.$tc('global.general.type'),
                    uploadedByEmployee: this.$t('pages.employeeDocuments.employeeUpload'),
                    confirmed: this.$t('global.ui.approved'),
                    sensitive: this.$t('pages.employeeDocuments.sensitive'),
                    visibleForEmployee: this.$t('pages.employeeDocuments.visible'),
                    creationDateFormatted: this.$t('store.settings.date'),
                    validUntilFormatted: " " + this.$t('global.general.expiringDate'),
                    actions: " ",
                };

            } else {
                stateDef = {
                    symbol: " ",
                    name: this.$t('pages.employeeData.name'),
                    uploadedByEmployee: this.$t('pages.employeeDocuments.employeeUpload'),
                    confirmed: this.$t('global.ui.approved'),
                    sensitive: this.$t('pages.employeeDocuments.sensitive'),
                    visibleForEmployee: this.$t('pages.employeeDocuments.visible'),
                    creationDateFormatted: this.$t('store.settings.date'),
                    validUntilFormatted: " " + this.$t('global.general.expiringDate'),
                    actions: " ",
                };
            }
            let state = this.$helpers.GetDataTableStateFromKeyLabelObject(stateDef, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'symbol');
            state.headerMap.symbol.componentStateBuilders = [() => {
                return {
                    componentType: 'buttonc',
                    type: 'button icon-overlay square',
                    icon: 'fas fa-file',
                    styleButton: {marginLeft: 'calc(50%-13px)'},
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
            state.headerMap['name'].componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.documentNameTruncatedFormat(data.name),
                    },
                    styleLabel: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '',
                        height: 'calc(100% - 10px)',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }
                }
            }];

             if(includeDocumentType){
                state.headerMap['documentType'].componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: this.documentTypeTruncatedFormat(data.documentType),
                        },
                        styleLabel: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                        }
                    }
                }];
            }

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'uploadedByEmployee');
            state.headerMap['uploadedByEmployee'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.uploadedByEmployee);
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'confirmed');
            state.headerMap['confirmed'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.confirmed);
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'sensitive');
            state.headerMap['sensitive'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.sensitive);
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'visibleForEmployee');
            state.headerMap['visibleForEmployee'].componentStateBuilders = [(data) => {
                return this.displayBooleanState(data.visibleForEmployee);
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDateFormatted');
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'validUntilFormatted');

            state.headerMap.actions.stylesEntry = {'justify-content': 'left'};
            state.headerMap.actions.componentStateBuilders = [
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.general.download')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-download',
                        customEvents: {
                            click: () => {
                                view.downloadFile(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.open')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-envelope-open',
                        customEvents: {
                            click: () => {
                                view.openFile(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.edit')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            data.confirmed || (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-edit',
                        customEvents: {
                            click: () => {
                                view.openEditModal(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.approve')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            data.confirmed || (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-file-check',
                        customEvents: {
                            click: () => {
                                view.confirmEmployeeFile(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('global.ui.unapprove')
                        },
                        hideInput: view.anonMode || !data.accessToken || !view.canViewFiles ||
                            !data.confirmed || (data.sensitive && !view.canViewSensitiveFiles),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-file-times',
                        customEvents: {
                            click: () => {
                                view.unconfirmEmployeeFile(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return view.$t('pages.employeeDocuments.changeSensitivity')
                        },
                        hideInput: !data.accessToken || !view.canViewSensitiveFiles,
                        type: 'button icon-overlay square',
                        icon: 'fas fa-user-secret',
                        customEvents: {
                            click: () => {
                                view.toggleFileSensitivity(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return view.$t('pages.employeeDocuments.changeEmployeeVisibility')
                        },
                        hideInput: !data.accessToken,
                        type: 'button icon-overlay square',
                        icon: 'fas fa-eye',
                        customEvents: {
                            click: () => {
                                view.toggleFileVisibility(data);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return "Löschen"
                        },
                        hideInput: (data.documentType === 'CONTRACT' && data.approved) || !data.deleteToken ||
                            (!view.canViewFiles || (data.sensitive && !view.canViewSensitiveFiles)),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-trash',
                        customEvents: {
                            click: () => {
                                view.openDeleteModal(data.id, data.documentType);
                            }
                        }
                    }
                },
            ];

            let entries = Object.entries(state.headerMap);

            if(includeDocumentType){
                entries[0][1].key = 'icon';
                entries[0][1].width = '3%';
                entries[1][1].key = 'name';
                entries[1][1].width = '20%';
                entries[2][1].key = 'documentType';
                entries[2][1].width = '15%';
                entries[3][1].key = 'uploadedByEmployee';
                entries[3][1].width = '7%';
                entries[4][1].key = 'confirmed';
                entries[4][1].width = '5%';
                entries[5][1].key = 'sensitive';
                entries[5][1].width = '5%';
                entries[6][1].key = 'visibleForEmployee';
                entries[6][1].width = '5%';
                entries[7][1].key = 'creationDateFormatted';
                entries[7][1].width = '15%';
                entries[8][1].key = 'validUntilFormatted';
                entries[8][1].width = '15%';
                entries[9][1].key = 'actions';
                entries[9][1].width = '15%';
            } else {
                entries[0][1].key = 'icon';
                entries[0][1].width = '3%';
                entries[1][1].key = 'name';
                entries[1][1].width = '25%';
                entries[2][1].key = 'uploadedByEmployee';
                entries[2][1].width = '7%';
                entries[3][1].key = 'confirmed';
                entries[3][1].width = '5%';
                entries[4][1].key = 'sensitive';
                entries[4][1].width = '5%';
                entries[5][1].key = 'visibleForEmployee';
                entries[5][1].width = '5%';
                entries[6][1].key = 'creationDateFormatted';
                entries[6][1].width = '15%';
                entries[7][1].key = 'validUntilFormatted';
                entries[7][1].width = '15%';
                entries[8][1].key = 'actions';
                entries[8][1].width = '15%';
            }


            state.headerStyles = {fontSize: '10px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.alwaysUnfold = false;
            return state;
        },
        displayBooleanState(val) {
            return {
                componentType: 'buttonc',
                type: 'button icon-overlay square',
                icon: val ? 'fas fa-check' : 'fas fa-times',
                styleButton: {marginRight: 'calc(50% - 13px)'},
            }
        },
        toggleSimpleEntries(documentType) {
            this.$nextTick(() => {
                let view = this;
                view.$set(view.collapsedState, documentType, !view.collapsedState[documentType]);
            });
        },
        getSharepointToken: function () {
            let view = this;
            let url = '/api/sec/employeefile/sharepoint/token';

            url = this.$helpers.appendParam("externalServiceId", this.sharepointServiceId, url, '/api/sec/employeefile/sharepoint/token');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/sharepoint/token');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            });
        },
        startFillDocuments(forceSingleMode = false) {
            if (!forceSingleMode) {
                this.modalFilldocuments = true;
                this.docfillpage = 1;
                this.filledDocuments = [];
                this.fillMlTemplates = true;
                this.loadDocumentTemplates();
            } else {
                this.openUploadTemplatePopup(forceSingleMode);
            }
        },
        openUploadTemplatePopup(forceSingleMode) {
            let view = this;
            let dataEntries = [
                {
                    divider: true
                },
                {
                    label: this.$t('pages.employeeDocuments.templateWithBubble'),
                    accept: ".docx,.pdf",
                    key: 'file',
                    hidden: false,
                    type: 'file',
                    value: null
                },
                {
                    divider: true
                },
                {
                    label: this.$t('pages.employeeDocuments.pastContract'),
                    key: 'pastContract',
                    hidden: false,
                    type: 'bool',
                    value: false,
                },
                {
                    label: this.$t('pages.employeeDocuments.futureContract'),
                    key: 'futureContract',
                    hidden: false,
                    type: 'bool',
                    value: false,
                },
                {
                    label: this.$t('pages.employeeDocuments.loadAsWordDoc'),
                    key: 'returnDocx',
                    hidden: false,
                    type: 'bool',
                    value: false
                }
            ];

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: {
                        file: (entries) => {
                            let errorObj = {
                                    key: 'error_div',
                                    type: 'error',
                                    label: this.$t('global.notifications.error').toUpperCase(),
                                    text: ''
                                };
                            let futureContract = entries.hasOwnProperty('futureContract')? entries['futureContract'] : false;
                            let pastContract = entries.hasOwnProperty('pastContract')? entries['pastContract'] : false;
                            if (entries.hasOwnProperty('file') && entries['file'] === null) {
                                // write error in error div as other solution looks a bit strange
                                errorObj.text = this.$t('store.settings.selectFile');
                            }
                            if(futureContract && pastContract){
                                let cur = "";
                                if(errorObj.text.length > 0) cur = "  |  ";
                                cur += this.$t('pages.employeeDocuments.cantPastAndFuture');
                                errorObj.text += cur;
                            }
                            if(errorObj.text.length > 0) return errorObj;
                            return null;
                        }
                    },
                    selectCallback: function (templatef) {
                        if (templatef.file != null) {
                            if (templatef.file.length > 0) {
                                view.uploadTemplate(templatef.file[0], templatef.futureContract, templatef.pastContract, templatef.returnDocx);
                            } else {
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeDocuments.noFileSelected'));
                            }
                            this.fillMlTemplates = false;
                        }
                    },
                    description: forceSingleMode ? this.$t('pages.employeeDocuments.noMlTemplate') : this.$t('pages.employeeDocuments.noMdTemplate'),
                    positiveButtonLabel: this.$t('pages.employeeDocuments.fillNow'),
                },
                header: this.$t('pages.employeeDocuments.selectTemplate'),
                remainAfterSelect: false,
                expanded: true,
                maxw50: true,
                centered: true
            });

        },
        uploadTemplate(file, futureContract = false, pastContract = false, returnDocx = false) {
            let view = this;
            const reader = new FileReader();
            reader.onload = () => {
                let b64 = reader.result;
                view.fillUploadedTemplate(file.name, b64, futureContract, pastContract, returnDocx);
            };
            reader.readAsDataURL(file);
        },
        endFillDocuments(){
            this.modalFilldocuments = false;
            this.resetFile(false);
            this.docfillpage = 1;
            this.filledDocuments = [];
            this.documentTemplates = [];
            this.templateTypes = [];
            this.docxDocuments = false;
        },
        getPreceedingContract(contract){
            let from = this.$helpers.getMomentFromStringTZ(contract.from);
            let prec = null;
            this.employeeContractArray.forEach((pc) => {
                if(pc.employeeId == this.employee.id){
                    let to = this.$helpers.getMomentFromStringTZ(pc.to);
                    let diff = this.$helpers.TimeDiff(from, to);
                    if(diff == 0){
                        prec = pc;
                    }
                }
            });
            return prec;
        },
        toggleFillPastContract(){
            this.fillPastContract = !this.fillPastContract;
            this.$forceUpdate();
            if(this.fillPastContract){
                this.fillFutureContract = false;
            }
        },
        toggleFillFutureContract(){
            this.fillFutureContract = !this.fillFutureContract;
            this.$forceUpdate();
            if(this.fillFutureContract){
                this.fillPastContract = false;
            }
        },
        fillUploadedTemplate(fileName, b64, futureContract = false, pastContract = false, returnDocx = false){
            let view = this;
            this.fillMlTemplates = false;
            this.loading = true;
            this.loadingText = this.$t('pages.employeeDocuments.waitAMoment');
            this.modalFilldocuments = true;
            let mimeType = "";
            if(fileName.includes(".docx")){
                mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            }else if(fileName.includes(".pdf")){
                mimeType = "application/pdf";
                returnDocx = false; // not possible with pdf template
            }
            console.log(fileName + ' with mime type ' + mimeType);
            this.docxDocuments = returnDocx;

            if(returnDocx){
                this.filledDocumentsType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            }else{
                this.filledDocumentsType = 'application/pdf';
            }
            let index = b64.indexOf('base64,');
            if(index != -1){
                index += 7;
                b64 = b64.substring(index);
            }
            let userFullname = this.userInfo.email; // fallback is email
            if(this.userInfo.firstname && this.userInfo.lastname){
                userFullname = this.userInfo.firstname + ' ' + this.userInfo.lastname;
            }
            let docDate = this.$helpers.getMomentTZ().format('DD.MM.YYYY');
            let payload = {
                storeId: this.$store.state.storeId,
                employeeId: this.employee.id,
                documentDate: docDate,
                userName: userFullname,
                userEmail: this.userInfo.email,
                single_b64: true,
                template_b64: b64,
                name_b64: fileName,
                returnDocx: returnDocx,
                type_b64: mimeType // only *.docx for now for single template processing
            }
            let docContract = this.contract;
            if(futureContract){
                //find the next contract in future
                let id = null;
                let now = this.$helpers.getMomentTZ();
                let fcontracts = this.employeeContractArray.filter(c => {
                    let ct = this.$helpers.getMomentFromStringTZ(c.from);
                    return c.employeeId == this.employeeId && ct >= now;
                }).sort((a,b) => {
                    let at = this.$helpers.getMomentFromStringTZ(a.from);
                    let bt = this.$helpers.getMomentFromStringTZ(b.from);
                    return at.unix() - bt.unix();
                })
                if(fcontracts.length > 0){
                    docContract = fcontracts[0];
                }
            }else if(pastContract){
                //find the next contract in future
                let id = null;
                let now = this.$helpers.getMomentTZ();
                let pcontracts = this.employeeContractArray.filter(c => {
                    let ct = null;
                    if(c.to != null){
                        ct = this.$helpers.getMomentFromStringTZ(c.to);
                    }
                    return c.employeeId == this.employeeId && ct != null && ct < now;
                }).sort((a,b) => {
                    let at = this.$helpers.getMomentFromStringTZ(a.from);
                    let bt = this.$helpers.getMomentFromStringTZ(b.from);
                    return bt.unix() - at.unix();
                })
                if(pcontracts.length > 0){
                    docContract = pcontracts[0];
                }
            }

            if(docContract != null && docContract != undefined){
                let id = docContract.id;
                if(id != null){
                    payload.contractId = id;
                }
                let preceedingContract = this.getPreceedingContract(docContract);
                if(preceedingContract != null){
                    let oId = preceedingContract.id;
                    if(oId != null){
                        payload.oldContractId = oId;
                    }
                }
            }
            let ids = [];

            //console.log('Calling docfill endpoint');
            //console.log(payload);

            let url = '/api/sec/docfill';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/docfill');
            localStorage.setItem('debug_payload', JSON.stringify(payload));
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.loading = false;
                //console.log(response);
                view.filledDocuments = response.data.data.data;
                view.docfillpage = 2;
            }).catch(function (error) {

                view.$helpers.error(view.$t('global.ui.createdErrorX', [view.$tc('global.general.document')]), view.$t('pages.employeeDocuments.uploadDocumentError'));
                console.log(error);
                view.endFillDocuments();
                view.loading = false;


            });
        },
        fillSelecetedDocuments(){
            let view = this;
            this.fillMlTemplates = true;
            let userFullname = this.userInfo.email; // fallback is email
            if(this.userInfo.firstname && this.userInfo.lastname){
                userFullname = this.userInfo.firstname + ' ' + this.userInfo.lastname;
            }
            let docDate = this.$helpers.getMomentTZ().format('DD.MM.YYYY');
            let payload = {
                storeId: this.$store.state.storeId,
                employeeId: this.employee.id,
                userName: userFullname,
                userEmail: this.userInfo.email,
                documentDate: docDate
            };

            let docContract = this.contract;
            if(this.fillFutureContract){
                //find the next contract in the future
                let id = null;
                let now = this.$helpers.getMomentTZ();
                let fcontracts = this.employeeContractArray.filter(c => {
                    let ct = this.$helpers.getMomentFromStringTZ(c.from);
                    return c.employeeId == this.employeeId && ct >= now;
                }).sort((a,b) => {
                    let at = this.$helpers.getMomentFromStringTZ(a.from);
                    let bt = this.$helpers.getMomentFromStringTZ(b.from);
                    return at.unix() - bt.unix();
                })
                if(fcontracts.length > 0){
                    docContract = fcontracts[0];
                }
            }else{
                //find the last contract that ended in the past
                let id = null;
                let now = this.$helpers.getMomentTZ();
                let pcontracts = this.employeeContractArray.filter(c => {
                    let ct = null;
                    if(c.to != null) {
                        ct = this.$helpers.getMomentFromStringTZ(c.to);
                    }
                    return c.employeeId == this.employeeId && ct != null && ct < now;
                }).sort((a,b) => {
                    let at = this.$helpers.getMomentFromStringTZ(a.from);
                    let bt = this.$helpers.getMomentFromStringTZ(b.from);
                    return bt.unix() - at.unix();
                })
                if(pcontracts.length > 0){
                    docContract = pcontracts[0];
                }
            }

            if(docContract != null && docContract != undefined){
                let id = docContract.id;
                if(id != null){
                    payload.contractId = id;
                }
                let preceedingContract = this.getPreceedingContract(docContract);
                if(preceedingContract != null){
                    let oId = preceedingContract.id;
                    if(oId != null){
                        payload.oldContractId = oId;
                    }
                }
            }
            let ids = [];
            this.documentTemplates.forEach((t) => {
                if(t.checked) ids.push(t.id);
            });
            payload.templates = ids.join(",");

            //console.log('Calling docfill endpoint');
            //console.log(payload);

            let url = '/api/sec/docfill';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/docfill');
            this.loading = true;
            this.loadingText = this.$t('pages.employeeDocuments.creatingDocuments');
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.loading = false;
                //console.log(response);
                view.filledDocuments = response.data.data.data;
                view.docfillpage = 2;
            }).catch(function (error) {
                view.$helpers.error(view.$t('pages.employeeDocuments.fillingDocumentsFailed'), '');
                console.log(error);
                //view.endFillDocuments();
                view.docfillpage = -1;
                view.loading = false;
            });

        },
        listFiles(queryFolder = null, updateState = true, queryFolderId = null){
            this.sharepointLoading = true;
            let view = this;
            let url = '/api/sec/employeefile/sharepoint';
            var rootId = this.sharepointRootID;
            if(queryFolder != null){
                queryFolderId = queryFolder.id;
            }
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/sharepoint');
            url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile/sharepoint');
            url = this.$helpers.appendParam("externalServiceId", this.sharepointServiceId, url, '/api/sec/employeefile/sharepoint');
            url = this.$helpers.appendParam("personnelId", this.$props.employee.personnelId, url, '/api/sec/employeefile/sharepoint');
            url = this.$helpers.appendParam("accessToken", this.sharepointToken, url, '/api/sec/employeefile/sharepoint');
            url = this.$helpers.appendParam("rootFolderId", this.sharepointRootID, url, '/api/sec/employeefile/sharepoint');
            if(queryFolderId != null){
                url = this.$helpers.appendParam("queryFolderId", queryFolderId, url, '/api/sec/employeefile/sharepoint');
            }

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                //console.log(response);
                view.sharepointFiles = [];
                view.sharepointFolders = [];
                if(updateState){
                    if(view.sharepointState.currentFolder == null){
                        view.sharepointState.currentFolder = {};
                    }
                    // set parent
                    if(view.sharepointState.parentFolder != null){
                        view.sharepointState.currentFolder.parent = view.sharepointState.parentFolder;
                    }
                    if(view.sharepointState.parentId != null){
                        view.sharepointState.currentFolder.parentId = view.sharepointState.parentId;
                    }
                    view.sharepointState.parentId = view.sharepointState.currentId;
                    view.sharepointState.parentFolder = view.sharepointState.currentFolder;
                    if(queryFolder != null && queryFolder.parentReference.id != rootId){
                        view.sharepointState.canGoUp = true;
                        view.sharepointState.currentFolder = queryFolder;
                        view.sharepointState.currentId = queryFolder.id;
                    }else{
                        view.sharepointState.canGoUp = false;
                        view.sharepointState.currentFolder = { parentId: rootId };
                        view.sharepointState.parentId = rootId;
                    }
                }
                response.data.forEach((f) => {
                    view.sharepointState.currentId = f.parentReference.id;
                    if(f.file != undefined){
                        view.sharepointFiles.push(f);
                    }else if(f.folder != undefined){
                        view.sharepointFolders.push(f);
                    }
                });
                view.sharepointLoading = false;
            }).catch(function (error){
                view.sharepointConnectionFailed(true);
            });
        },
        getSharepointFiles: function(queryFolder = null, updateState = true, queryFolderId = null){
            let view = this;
            this.sharepointLoading = true;
            if(this.sharepointToken == null){
                console.log('Fetching sharepoint token');
                view.getSharepointToken().then((response) => {
                    console.log(response);
                    if(response.data.type == "SUCCESS"){
                        view.sharepointToken = response.data.data;
                        view.listFiles(queryFolder, updateState, queryFolderId);
                    }else{
                        view.sharepointConnectionFailed(false);
                    }
                }).catch(function (error){
                    view.sharepointConnectionFailed(false);
                });
            }else{
                console.log('Using cached token');
                view.listFiles(queryFolder, updateState, queryFolderId);
            }
        },
        sharepointConnectionFailed(withToken){
            this.sharepointLoading = false;
            let desc = withToken? this.$t('pages.employeeDocuments.loadingSharepointFailed') : this.$t('pages.employeeDocuments.noSharepointConnection');
            let view = this;
            window.app.popupalerts.push({header: withToken? view.$t('indicator.crew.loadingError') : this.$t('store.settings.connectionError'), number: null, description: desc, hidden: false, callbackAccept: function(popup){
                    popup.hidden = true;
                }, disableCancel: true
            });
        },
        listParent(){
            let view = this;
            var parent = view.sharepointState.parentFolder;
            var parentId = view.sharepointState.parentId;
            if(parent != null || parentId != null){
                if(parent != null){
                    var parentParent = parent.parent;
                    if(parentParent != null){
                        view.sharepointState.canGoUp = true;
                        view.sharepointState.parentFolder = parentParent;
                        view.sharepointState.currentFolder = parent;
                        view.sharepointState.currentId = parent.id;
                        view.sharepointState.parentId = parentParent.id;
                    }else if(parentId != null){
                        // root level
                        view.sharepointState.canGoUp = true;
                        view.sharepointState.parentFolder = null;
                        view.sharepointState.currentFolder = parent;
                        view.sharepointState.currentId = view.sharepointState.parentId;
                        view.sharepointState.parentId = null;
                    }else{
                        view.sharepointState.canGoUp = false;
                        view.sharepointState.parentFolder = null;
                        view.sharepointState.currentFolder = null;
                        view.sharepointState.currentId = null;
                        view.sharepointState.parentId = null;
                    }
                }else{
                    view.sharepointState.canGoUp = false;
                    view.sharepointState.parentFolder = null;
                    view.sharepointState.currentFolder = null;
                    view.sharepointState.currentId = null;
                    view.sharepointState.parentId = null;
                }

            }
            var updateState = view.sharepointState.currentFolder == null && view.sharepointState.currentId == null;
            view.getSharepointFiles(view.sharepointState.currentFolder, updateState, view.sharepointState.currentId);
        },
        downloadSharepointFile(file){
            window.open(file['@microsoft.graph.downloadUrl']);
        },
        openSharepointFile(file){
            window.open(file.webUrl);
        },
        refresh: function () {
            let view = this;
            view.$helpers.GetEmployeeFilesMap()
            .then(response => {
                //view.updateFiles();
            }).catch(function (error) {
                console.log(error)
            });

            if(view.employee.remoteId != null){
                view.socialInsuranceRegistrations = [];
                view.mlEmployeeFiles = [];
                view.loadSocialInsuranceRegistrations();
                view.loadMLEmployeeFiles();
            }


            view.loadStoreExternalData()
            .then(response => {
                view.updateStoreExternalData(response.data);
                view.$helpers.GetExternalServicesMap().then((services) => {
                    if(view.hasSharepoint && view.hasSharepointConfig){
                        view.getSharepointFiles();
                        view.$emit('document-upload-enabled', true);
                    }else{
                        view.$emit('document-upload-enabled', true);
                    }
                });
            });
        },

        fileUploadDataError(){
            if(!this.employeeFile.upload) return this.$t('store.settings.selectFile');
            else if(!this.employeeFile.name) return this.$t('pages.employeeDocuments.selectName');
            else if(!this.employeeFile.documentType || this.employeeFile.documentType === 'UNDEFINED') return this.$t('pages.employeeDocuments.selectDocumentType');
            return null;
        },
        selectFileForUpload(){
            let elem = document.getElementById('fileUploaderLabel');
            console.log(elem);
            if (elem) {
                elem.click();
            }
        },
        selectFileForUploadFromParent(){
            let elem = document.getElementById('file-outer');
            elem.click();
        },
        fileSelected(event, openModal = false){
            let view = this;

            this.employeeFile.upload = event.target.files[0];
            if(this.employeeFile.upload){
                if(this.employeeFile.name == null || this.employeeFile.name.length === 0){
                    let split = this.employeeFile.upload.name.split(".");

                    this.employeeFile.name = split.length > 0 ? split[0].substring(0, 20) : "";
                }

                console.log('File selected, openModal: ' + openModal);
                if(openModal) this.modalCreatefile = true;
                let reader = new FileReader();
                reader.onload = function (e){
                    if(view.employeeFile.upload.type === "application/pdf"){
                        view.preview = false;
                        view.previewPdf = true;
                        view.previewPdfSrc = e.target.result;
                    }else{
                        view.previewPdf = false;
                        view.preview = true;
                        view.previewSrc = e.target.result;
                    }
                };
                reader.readAsDataURL(this.employeeFile.upload);
            }
        },
        pageCountLoaded(event){
            this.pageCount = event;
            this.$forceUpdate();
        },
        prevPage(){
            if(this.page > 1) this.page = this.page - 1;
        },
        nextPage(){
            if(this.page < this.pageCount) this.page = this.page + 1;
        },
        resetFile(frontendOnly = false){
            this.previewSrc = '';
            this.preview = false;
            this.previewPdfSrc = '';
            this.previewPdf = false;
            this.uploading = false;
            if(!frontendOnly){
                this.employeeFile = {
                    upload: null,
                    name: "",
                    hasValidUntil: false,
                    validUntil: this.$helpers.getMomentTZ().add(7,'days').format("YYYY-MM-DD"),
                    documentType: 'UNDEFINED',
                    sensitive: false,
                    visibleForEmployee: true
                }
            }
        },
        openFile(item){
            let url = "";
            if(item.url){
                url+=item.url
            } else {
                url ="https://fileserver1.meindienstplan.de"
            }
            url+='/api/file?id=';
            if(item.fileId){
                url+= item.fileId
            } else if(item.id){
                url+= item.id
            }
            url+='&accessToken='+item.accessToken

            window.open(url, '_blank');
        },
        downloadFile(item){
            let url = "";
            if(item.url){
                url+=item.url
            } else {
                url ="https://fileserver1.meindienstplan.de"
            }
            url+='/api/file?id=';
            if(item.fileId){
                url+= item.fileId
            } else if(item.id){
                url+= item.id
            }
            url+='&accessToken='+item.accessToken;
            let fileEnding = this.fileTypeMapping[item.fileType] ? this.fileTypeMapping[item.fileType]: null;
            this.$helpers.DownloadFileFromFileServer(url, item.name, fileEnding)
        },
        openEldaFile(requestId){
            let view = this;
            let url = '/api/sec/employeefile/elda/print';
            let params = {
                storeId: this.$store.state.storeId,
                requestId: requestId,
                companyId: this.storeSettings.companyId
            }


            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                if(response.data.pdf != null){
                    let blob= view.$helpers.b64toBlob(response.data.pdf, 'application/pdf');

                    var fileURL = window.URL.createObjectURL(blob);
                    let tab = window.open();
                    tab.location.href = fileURL;

                } else {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                }

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                console.log(error);
            })
        },
        upsertFile: function (event) {
            if (this.modalEditfile) {
                this.editFile();
            } else {
                this.createFile(event);
            }
        },
        createFile: function (evt) {
            evt.preventDefault();
            if(this.employeeFile.name == ""){
                this.employeeFile.name = this.documentTypeFormat(this.employeeFile.documentType);
            }
            this.uploadErrorMessage = this.fileUploadDataError();
            if(this.uploadErrorMessage == null){
                this.fileerror = false;
                let view = this;
                let url = '/api/sec/employeefile/upload';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/upload');

                let formData = new FormData();
                formData.append("employeeId", this.$props.employeeId);
                formData.append("name", this.employeeFile.name);
                formData.append("documentType", this.employeeFile.documentType);
                formData.append("sensitive", this.employeeFile.sensitive);
                formData.append("visibleForEmployee", this.employeeFile.visibleForEmployee);
                formData.append('file', this.employeeFile.upload);
                if(this.employeeFile.hasValidUntil){
                    formData.append("validUntil", this.$helpers.getMomentFromStringTZ(this.employeeFile.validUntil, "YYYY-MM-DD").format());

                }
                this.uploading = true;
                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: formData
                }).then(response => {
                    let file = response.data.data;


                    view.uploading = false;
                    view.resetFile(false);
                    view.modalCreatefile = false;
                    view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('global.ui.createdX', [view.$tc('global.general.document')]));
                    view.$emit('filesUpdated');
                }).catch(function (error) {
                    view.fileerror = true;
                    view.uploading = false;
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createdErrorX', [view.$tc('global.general.document')]));
                    console.log(error)
                })
            }else{
                this.backupFile = this.employeeFile;
                this.modalUploadError = true;
            }
        },
        closeErrorModal(){
            this.modalUploadError = false;
            this.employeeFile = this.backupFile;
        },
        openEditModal: function (item) {
            let url = '/api/employeefile/content?fileId='+item.fileId+'&accessToken='+item.accessToken+'&url='+item.url;
            let fileType = item.fileType;
            if(fileType == 'application/pdf'){
                this.previewPdf = true;
                this.preview = false;
            }else{
                this.previewPdf = false;
                this.preview = true;
            }
            this.employeeFile = {
                name: item.name,
                documentType: item.documentType,
                fileType: item.fileType,
                hasValidUntil: item.validUntil != null,
                validUntil: item.validUntil == null ? (this.$helpers.getMomentTZ().add(7,'days').format("YYYY-MM-DD")) : (this.$helpers.getMomentFromStringTZ(item.validUntil).format("YYYY-MM-DD")),
                url: url
            };
            this.fileId = item.id;
            this.modalEditfile = true;
        },
        editFile: function () {
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeefile';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');

            let payload = {
                id: this.fileId,
                name: this.employeeFile.name,
                documentType: this.employeeFile.documentType,
                validUntil: null,
                updateFields: ["name", "documentType", "validUntil"]
            }
            if(this.employeeFile.hasValidUntil){

               payload.validUntil = this.$helpers.getMomentFromStringTZ(this.employeeFile.validUntil, "YYYY-MM-DD").format();
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(() => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.notifications.updateMessage'));
                view.$emit('filesUpdated');
                view.modalEditfile = false;
                view.resetFile(false);
            }).catch(function (error) {
                view.fileerror = true;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.general.document')]));
                console.log(error);
            })

        },
        toggleFileSensitivity: function (file) {

            let view = this;
            let url = '/api/sec/employeefile';


            let params = {
                id: file.id,
                storeId: this.$store.state.storeId

            }

            let payload = {
                id: file.id,
                sensitive: !file.sensitive,
                updateFields: ["sensitive"]
            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                file.sensitive = !file.sensitive;
                view.$forceUpdate();
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.notifications.updateMessage'));
                view.$emit('filesUpdated');

            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.general.document')]));
                console.log(error)
            })

        },
        toggleFileVisibility: function (file) {

            let view = this;
            let url = '/api/sec/employeefile';


            let params = {
                id: file.id,
                storeId: this.$store.state.storeId

            }

            let payload = {
                id: file.id,
                visibleForEmployee: !file.visibleForEmployee,
                updateFields: ["visibleForEmployee"]
            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                file.visibleForEmployee = !file.visibleForEmployee;
                view.$forceUpdate();
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.notifications.updateMessage'));
                view.$emit('filesUpdated');

            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.general.document')]));
                console.log(error)
            })

        },
        confirmEmployeeFile: function (file) {

            let view = this;
            let url = '/api/sec/employeefile/confirm';


            let params = {
                id: file.id,
                storeId: this.$store.state.storeId

            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                file.confirmed = true;
                view.$forceUpdate();
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.notifications.updateMessage'));
                view.$emit('filesUpdated');

            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.general.document')]));
                console.log(error)
            })

        },
        confirmAllEmployeeFile: function () {

            let view = this;
            let url = '/api/sec/employeefile/confirm/all';


            let params = {
                employeeId: this.employee.id,
                storeId: this.$store.state.storeId

            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                view.files.forEach(file => {
                    file.confirmed = true;
                })
                view.$forceUpdate();
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.notifications.updateMessage'));
                view.$emit('filesUpdated');

            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.general.document', 2)]));
                console.log(error)
            })

        },
        unconfirmEmployeeFile: function (file) {

            let view = this;
            let url = '/api/sec/employeefile/unconfirm';

            let params = {
                id: file.id,
                storeId: this.$store.state.storeId

            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                file.confirmed = false;
                file.confirmDate = null;
                file.confirmedBy = null;
                file.confirmedByName = null;
                view.$forceUpdate();
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.notifications.updateMessage'));
                view.$emit('filesUpdated');

            }).catch(function (error) {

                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.editedErrorX', [view.$tc('global.general.document', 2)]));
                console.log(error)
            })

        },
        openDeleteModal: function (id, documentType) {
            this.fileId = id;
            this.docType = documentType;
            if (this.docType === 'CONTRACT') {
                this.modalDeletecontractfile = true;
            } else {
                this.modalDeletefile = true;
            }
        },
        deleteFile: function () {
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeefile';

            url = this.$helpers.appendParam("id", this.fileId, url, '/api/sec/employeefile');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                const index = this.files.findIndex(file => file.id === view.fileId) // find the filesinessunit index
                if(view.docType == 'CONTRACT'){
                    view.$emit('contract-deleted', view.fileId);
                }
                if (~index) {
                    view.files.splice(index, 1);
                }
                view.modalDeletefile = false;
                view.modalDeletecontractfile = false;
                view.$emit('filesUpdated');
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            })
        },



        loadDocumentTemplates: function(){
            this.loadingText = this.$t('workBalance.averages.loading');
            this.loading = true;
            let view = this;
            let url = '/api/sec/documenttemplates';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/documenttemplates');
            setTimeout(() => {
                view.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url
                }).then((response) => {
                    console.log('COMPANY TEMPLATES');
                    console.log(response);
                    view.loading = false;
                    if(response.data.templates[0].length > 0 || response.data.templates.length > 1 && response.data.templates[1].length > 0){
                        let sTemplates = response.data.templates[0];
                        let cTemplates = response.data.templates.length > 1? response.data.templates[1] : [];
                        sTemplates.forEach((t) => {
                            t.checked = false;
                            t.company = false;
                        });
                        cTemplates.forEach((t) => {
                            t.checked = false;
                            t.company = true;
                        });
                        let templates = sTemplates.concat(cTemplates);
                        view.documentTemplates = templates;
                        view.templateTypes = response.data.types;
                    }else{
                        view.modalFilldocuments = false;
                        view.startFillDocuments(true);
                    }
                }).catch(error => {
                    view.modalFilldocuments = false;
                    view.resetFile(false);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.employeeDocuments.loadingMlError'));


                    view.openUploadTemplatePopup(true);
                });
            }, 1000);

        },
        loadSocialInsuranceRegistrations: function () {
            let view = this;
            let url = '/api/sec/employeefile/socialinsuranceregistrations';
            let params = {
                storeId: this.$store.state.storeId,
                employeeId: this.$props.employeeId,
                companyId: this.storeSettings.companyId
            }


            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {

                view.socialInsuranceRegistrations = response.data;
            }).catch(function (error) {
                //view.$helpers.error('Fehler', 'Fehler beim Laden der Sozialversicherungen');
                console.log(error);
            })

        },
        loadMLEmployeeFiles: function () {
            let view = this;
            let url = '/api/sec/employeefile/ml';
            let params = {
                storeId: this.$store.state.storeId,
                employeeId: this.$props.employeeId,
                companyId: this.storeSettings.companyId
            }


            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {

                view.mlEmployeeFiles = response.data;
            }).catch(function (error) {
                //view.$helpers.error('Fehler', 'Fehler beim Laden der Sozialversicherungen');
                console.log(error);
            })

        },
        templatesWithType(type){
            let result = [];
            this.documentTemplates.forEach((t) => {
                if(t.template_type == type.id) result.push(t);
            });
            return result;
        },
        b64ToFile(b64){
            var byteCharacters = atob(b64);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], { type: this.filledDocumentsType + ';base64' });
            return file;
        },
        openFilledDocumentB64(doc){
            if(this.fillMlTemplates){
                let pdfWindow = window.open("")
                pdfWindow.document.write(
                    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                    encodeURI(doc.data) + "'></iframe>"
                )
            }else{
            var file = this.b64ToFile(doc.data);
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            }
        },
        docFilename(doc){
            let filename = doc.fileName;
            if(this.docxDocuments){
                filename = filename.replace('.docx', this.employeeFilenameAppendix + '.docx');
            }else{
                filename = filename.replace('.pdf', this.employeeFilenameAppendix + '.pdf');
            }
            return filename;
        },
        saveFilledDocumentB64(doc){
            var file = this.b64ToFile(doc.data);
            saveAs(file, this.docFilename(doc));
        },
        saveAllDocsB64(){
            this.filledDocuments.forEach((doc) => {
                this.saveFilledDocumentB64(doc);
            });
        },
        loadStoreExternalData: function(){
            let url = '/api/sec/storeexternaldata';
            //url = this.$helpers.appendParam("id", this.$store.state.storeId, url, '/api/sec/storeexternaldata');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storeexternaldata');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            });
        },
        updateStoreExternalData: function(data){
            let edataMap = {};
            data.forEach((item) => {
                edataMap[item.id] = item;
            });

            this.externalDataMap = edataMap;
        },
        hideModal(ref) {
            this.fileerror = false;
            this.fileId = "";
            this.employeeFile = {
                name: "",
                documentType: "ID",
                upload: null,
            },
            this.currentrow = {};
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
        creationDateFormat(str){
            return this.$helpers.getMomentFromStringTZ(str).format("DD.MM.YYYY | HH:mm");
        },
        localDate(str){
            return str == null ? "-" : this.$helpers.getMomentFromStringTZ(str, "YYYY-MM-DD").format("DD.MM.YYYY");
        },
        validUntilFormat(str){
            return str == null ? "-" : this.$helpers.getMomentFromStringTZ(str).format("DD.MM.YYYY");
        },
        documentTypeFormat(key){
            return this.$helpers.documentTypeLabel(key);
        },
        documentTypeTruncatedFormat(key){
            let t = this.$helpers.documentTypeLabel(key);
            if( t && t.length > 20){
                t = t.substring(0,20) + '...';
            }

            return t
        },
        documentNameTruncatedFormat(t){
            return this.documentNameTruncatedFormatTo(t, 20);
        },
        documentNameTruncatedFormatTo(t, val){
            if(this.anonMode){
                return 'Anonymous Document'
            }
            if( t && t.length > val){
                t = t.substring(0,val) + '...';
            }

            return t
        }
    }
}
</script>

<!-- Add "scoped" attrifilete to limit CSS to this component only -->

<style scoped>

.fa-spinner{
    position:absolute;
    top: 150px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: var(--contrast-3);
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

.docfillpopup .subheader{
    width: 100%;
    margin: 16px 0px 8px 0px;
    box-shadow: 0 2px 0 -1px var(--contrast-2);
}

.docfillpopup .subheader .label{
    font-family: DistrictProBold;
    font-size: 14px;
    color: var(--md);
    margin: 0px 50px 0px 50px;
}

.docfillpopup .data.label{
    font-family: DistrictProBook;
    font-size: 11px;
    color: var(--contrast-4);
    margin: 0px 0px 0px 50px;
}

.dropdownbtn {
  text-align: right;
  padding: 0;
  margin: 0;
  border: 0;
}

.dropdownbtn:focus {
  box-shadow: none;
}

.doc-table {
    min-width: 750px;
}

.md-card-select.settings {
    border: none;
    padding: 0 48px;
}

.md-card-select {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
}

.md-card-select.template-line {
    padding: 4px;
}

.md-card-select.file-line {
    padding: 8px 4px;
}

.md-card-select .md-label {
    width: 20%;
}
.md-card-select .input {
    width: min(69%, 500px);
}

.md-card-select .cb-group{
    margin-top: 10px;
}

.md-card-select .cb-group-template {
    margin-top: 0px;
}

.md-card-select .cd-input {
    width: min(69%, 500px);
}

.md-card-select .select-style {
    width: 69%;
}
.page-settings .header {
    margin-top: 16px;
    box-shadow: none!important;
}

.md-card {
    position: fixed;
    z-index: 1000000;
    left: calc(50vw - 360px);
    height: 100vh - 200px;
    width: 720px;
    padding-bottom: 10px;
    top: 89px;
    resize: none;
    overflow: auto;
}

.md-card-body {
    max-height: calc(96vh - 160px);
    overflow-y: auto;
}

.preview-box {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    width: calc(90% - 10px);
    height: auto;
    min-height: 240px;
    margin: 12px 5px;
}

.img-preview{
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-height: 232px;
    border-radius: 5px;
    object-fit: scale-down;
}

.next, .previous {
    width: 5%
}

.inputFile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.inputFile + label:hover {
    color: var(--bg);
    background-color: var(--md);
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
}

.remove-picture {
    position: absolute;
    right: 50px;
    top: 48px;
}

.discarder {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color:rgba(0, 0, 0, 0.5);
    z-index: 100000;
}

.w600 {
    width: 600px;
}
</style>
